<template>
    <div>
        <template v-if="loading">
            <loading :size="size" type="spinner" :color="color"/>
            <span>{{loadingText}}</span>
        </template>
        <template v-else>
            <span>{{text}}</span>
        </template>
    </div>
</template>

<script>
	import {Loading} from 'vant';

	export default {
		name: '',
		props: {
			loading: {
				type: Boolean,
				default: false,
			},
			text:{
				type:String,
                default: '确定'
            },
			loadingText:{
				type:String,
                default: '处理中...'
            },
            color:{
				type:String,
                default:'white'
            },
            size:{
				type:String,
                default:'20px'
            }
		},
		components: {
			Loading,
		},
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
    div{
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    span{
        * + &{
            padding-left: 5px;
        }
    }
</style>